exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unit-charge-info[data-v-47c0bbf4] {\n  font-size: small;\n  color: darkgrey;\n  font-weight: 400;\n}\n", ""]);

// exports
